import { AccordionDetails, Link, List, ListItem, styled } from "@mui/material";

export const Styled = {
    UnorderedList: styled(List)`
        list-style: disc;
        margin-left: 16px;
    `,
    AccordionDetails: styled(AccordionDetails)`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
    ListItem: styled(ListItem)`
        display: list-item;
        padding: 0;
    `,
    Link: styled(Link)`
        color: white;
    `,
};
